import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
import print from 'vue3-print-nb'
import './style.css'
import App from './App.vue'
import router from './utils/routes'
import {storeConfig} from './utils/store'
// @ts-ignore
import TimeLine from './components/TimeLine/index.js'

//先获取配置文件
fetch('/sysconfig.json')
.then(response => response.json())
.then(data => {
  const app= createApp(App)
  app.use(print)
  app.use(router)
  app.use(createPinia().use(piniaPluginPersist))
  app.use(TimeLine, { comName: 'TimeLine' })
  let storconfig = storeConfig()
  storconfig.setConfig('centerBaserurl', data.baseurlCenter)
  storconfig.setConfig('tenantBaseurl', data.baseurlTenant)
  storconfig.setConfig('domainUrl', data.domainUrl)
  if (window.location.href.includes('hdjp.hemikj.com')) storconfig.setConfig('domain', 'hdjp')
  else if (window.location.href.includes('shop.hemikj.com')) storconfig.setConfig('domain', 'khjp')
  else if (window.location.href.includes('jp.xtgyl.cn')) {
    storconfig.setConfig('domain', 'zbjp')
    setFavicon()
  } else storconfig.setConfig('domain', 'jp')
  app.mount('#app')
})
.catch(error => {
  console.error('读取JSON文件时发生错误:', error)
})

const setFavicon = () => {
  let iconUrl = '/zbfavicon.png'
  // 确保iconUrl完整，如果相对路径，会自动基于当前页面解析
  // 可以添加时间戳强制刷新缓存（可选）
  // 如果希望每次更新都刷新缓存，可以添加随机参数，但这样每次页面加载都会重新请求，不是必须，但为了避免缓存问题可以取消注释
  // if (iconUrl.indexOf('?') === -1) iconUrl += '?_=' + Date.now();
  // 查找现有 rel="icon" 的link标签
  // const existingIcons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
  let links:any = document.querySelectorAll('link[rel*="icon"]');
  // 移除所有现有的icon link
  for (let i = 0; i < links.length; i++) {
    links[i].parentNode.removeChild(links[i]);
  }
  // 创建新的link元素
  var link = document.createElement('link');
  link.rel = 'icon';
  link.href = iconUrl;
  // 可选设置type，如图标是png可以设置type="image/png"
  // 根据扩展名简单判断，或者不设置
  document.title = '中邦餐饮'
  document.head.appendChild(link);
}